import { render, staticRenderFns } from "./FeaturedContent1.vue?vue&type=template&id=2f2a8867"
import script from "./FeaturedContent1.vue?vue&type=script&lang=js"
export * from "./FeaturedContent1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default})
